import RefreshIcon from '@mui/icons-material/Refresh';
import { ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttButton } from '../all';

type SttButtonRefreshProps = {
    onClick: () => void;
    caption?: string;
} & ButtonProps;

/**
 * Refresh button
 */
export function SttButtonRefresh({
    onClick,
    caption,
    ...rest
}: SttButtonRefreshProps) {
    const { t } = useTranslation();

    return (
        <SttButton
            variant="text"
            onClick={onClick}
            startIcon={<RefreshIcon />}
            color="primary"
            caption={caption || t('Refresh')}
            {...rest}
        />
    );
}
